import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FontWeight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.70044 2.45581C2.4243 2.45581 2.20044 2.67967 2.20044 2.95581C2.20044 3.23195 2.4243 3.45581 2.70044 3.45581H7.64941L7.64941 14.543C7.64941 14.8192 7.87327 15.043 8.14941 15.043C8.42556 15.043 8.64941 14.8192 8.64941 14.543L8.64941 3.45581H13.5969C13.8731 3.45581 14.0969 3.23195 14.0969 2.95581C14.0969 2.67967 13.8731 2.45581 13.5969 2.45581H2.70044Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.96659 7.07491C4.16185 7.27018 4.16185 7.58676 3.96659 7.78202L2.34313 9.40548L3.96659 11.0289C4.16185 11.2242 4.16185 11.5408 3.96659 11.7361C3.77133 11.9313 3.45475 11.9313 3.25948 11.7361L1.28247 9.75904C1.08721 9.56377 1.08721 9.24719 1.28247 9.05193L3.25948 7.07491C3.45475 6.87965 3.77133 6.87965 3.96659 7.07491Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2548 7.07491C12.0596 7.27018 12.0596 7.58676 12.2548 7.78202L13.8783 9.40548L12.2548 11.0289C12.0596 11.2242 12.0596 11.5408 12.2548 11.7361C12.4501 11.9313 12.7667 11.9313 12.962 11.7361L14.939 9.75904C15.1342 9.56377 15.1342 9.24719 14.939 9.05193L12.962 7.07491C12.7667 6.87965 12.4501 6.87965 12.2548 7.07491Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default FontWeight
